<template>
    <v-container :class="!!getNumPages ? 'loaded-pdf' : 'loading-pdf'">
        <template v-if="!!getNumPages">
            <div class="container-pdf" :class="{ 'zoom-active': zoom < 10 }">
                <pdf
                    v-for="i in numPages"
                    :key="i"
                    :page="i"
                    :src="src"
                    style="display: inline-block;"
                    :style="{ width: zoom + '%' }"
                >
                </pdf>
            </div>
        </template>
        <template v-else>
            <v-row class="justify-center align-center">
                <v-col cols="auto">
                    <RomaWait message="Cargando información" />
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import pdf from "vue-pdf";
import { mapActions, mapGetters } from "vuex";
import RomaWait from "../../components/commons/RomaWait";

export default {
    props: ["pdfDoc"],
    name: "RomaPDF",
    components: {
        pdf,
        RomaWait
    },
    data() {
        return {
            numPages: undefined,
            currentPage: 1,
            loadedRatio: 0,
            page: 1,
            rotate: 0,
            show: true,
            pageCurrent: 0,
            pageLabel: "1",
            disableNext: false,
            disablePrev: true,
            src: null,
            direction: "top",
            fab: false,
            fling: false,
            hover: false,
            tabs: null,
            top: false,
            right: true,
            bottom: true,
            left: false,
            transition: "slide-y-reverse-transition"
        };
    },
    computed: {
        ...mapGetters({
            zoom: "getZoom",
            getLoadedPdf: "getLoadedPdf"
        }),
        activeFab() {
            switch (this.tabs) {
                case "one":
                    return { class: "purple", icon: "account_circle" };
                case "two":
                    return { class: "red", icon: "edit" };
                case "three":
                    return { class: "green", icon: "keyboard_arrow_up" };
                default:
                    return {};
            }
        },
        getNumPages() {
            return this.numPages;
        }
        /*,
        src() {
          return pdf.createLoadingTask(`${this.pdfDoc}`);
        },*/
    },
    watch: {
        top(val) {
            this.bottom = !val;
        },
        right(val) {
            this.left = !val;
        },
        bottom(val) {
            this.top = !val;
        },
        left(val) {
            this.right = !val;
        },
        pdfDoc(val){
            this.src = pdf.createLoadingTask(`${val}`);
            this.src.promise.then(pdf => {
                this.numPages = pdf.numPages;
                this.setLoadedPdf({ loadedPdf: true });
            });
        }
    },
    mounted() {
        this.setLoadedPdf({ loadedPdf: false });
        this.src = pdf.createLoadingTask(`${this.pdfDoc}`);
        this.src.promise.then(pdf => {
            this.numPages = pdf.numPages;
            this.setLoadedPdf({ loadedPdf: true });
        });
    },
    methods: {
        ...mapActions({
            setLoadedPdf: "setLoadedPdf"
        }),
        next() {
            this.currentPage += 1;
            this.currentPage =
                this.currentPage >= this.numPages
                    ? this.numPages
                    : this.currentPage;
            this.disableNext = this.currentPage >= this.numPages;
            this.disablePrev = this.currentPage <= 1;
        },
        change() {
            this.disableNext = this.currentPage >= this.numPages;
            this.disablePrev = this.currentPage <= 1;
        },
        previous() {
            this.currentPage -= 1;
            this.currentPage = this.currentPage <= 1 ? 1 : this.currentPage;
            this.disablePrev = this.currentPage <= 1;
            this.disableNext = this.currentPage >= this.numPages;
        },
        numberPages() {
            const pages = [];
            for (let index = 0; index < this.numPages; index++) {
                pages.push({ index: index + 1, label: index + 1 });
            }
            return pages;
        }
    }
};
</script>

<style lang="scss">
canvas {
    border-radius: 25px !important;
    margin-bottom: 15px;
    width: 100% !important;
}

.button-zoom {
    position: fixed;
    bottom: 125px;
    right: 20px;
    z-index: 5000;
}

.container-pdf {
    height: 180vh;
    padding: 0;
    overflow-y: scroll;
    border-radius: 35px !important;
    width: 100%;
    &.zoom-active {
        cursor: grab;
    }
}

@media (max-width: 800px) {
    canvas {
        border-radius: 5px !important;
        margin-bottom: 15px;
    }
    .container-pdf {
        height: 100vh;
        width: 100%;
        border-radius: 5px !important;
    }
}
#create .v-speed-dial {
    position: absolute;
}

#create .v-btn--floating {
    position: relative;
}
</style>
